export enum Direction {
  RIGHT = 0,
  DOWN = 1,
  LEFT = 2,
  UP = 3,
}

export const ALL_DIRECTIONS = [
  Direction.RIGHT,
  Direction.DOWN,
  Direction.LEFT,
  Direction.UP,
];
